<div class="log" [ngStyle]="{'minHeight.px':  minScrollHeight}"  #logContainer>
  <div class="virtual-scroll-container" [style.marginBottom.px]="bottomSpace" #messageContainer>
    <ng-container *ngIf="0 < chatMessages.length">
      <ng-container *ngFor="let chatMessage of chatMessages; trackBy: trackByChatMessage">
        <chat-message-ease *ngIf="chatMessage.isDisplayable"
        [chatMessage]="chatMessage" [localFontsize]='this.localFontsize' [bgColor]='this.bgColor' [isSelected]="selectMessageIdentifier === chatMessage.identifier" (click)="selectMessage(chatMessage)" (dblclick)="editMessage(chatMessage)">
        </chat-message-ease>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="chatMessages.length <= 0">
      <chat-message-ease *ngFor="let chatMessage of sampleMessages" [chatMessage]="chatMessage">
      </chat-message-ease>
    </ng-container>
    <div class="spacer" [class]="bgColor"></div>
  </div>
</div>
